import { useEffect } from "react";

/** Client-side title for in-app navigation; the server sets the first one. */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
